{
  "SEARCH": {
    "TABS": {
      "ALL": "Tutti",
      "CONTACTS": "Contatti",
      "CONVERSATIONS": "Conversazioni",
      "MESSAGES": "Messaggi"
    },
    "SECTION": {
      "CONTACTS": "Contatti",
      "CONVERSATIONS": "Conversazioni",
      "MESSAGES": "Messaggi"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Type 3 or more characters to search",
    "RECENT_MESSAGES": "I miei messaggi inviati di recente",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "da",
    "EMAIL": "email",
    "EMAIL_SUBJECT": "oggetto"
  }
}
